import { Controller } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import dayjs from "dayjs";
import { colors } from "../../styles/colors";
const minDate = dayjs("2000-01-01");

const CustomDate: React.FC<{
  clearError?: any;
  control: any;
  name: any;
  label: string;
  rules?: any;
  readonly?: boolean;
  onDateChange?: () => void; 
}> = ({ control, name, label, rules, readonly,onDateChange }, props) => {
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field: { onChange, value } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            components={{
              OpenPickerIcon: CalendarMonthOutlinedIcon,
            }}
            inputFormat="dd/MM/yyyy"
            label={((value === null) || (value === undefined)) && label}
            onChange={(newValue) => {
              onChange(newValue);
              if (props?.clearError) {
                props?.clearError(name);
              }
              if(onDateChange){
                onDateChange()
              }
            }}
            value={value || null}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  border: `1px solid ${colors.gray_white}`,
                  borderRadius: "4px",
                  "& fieldset": { border: "none" },
                }}
                InputLabelProps={{ shrink: false }}
              />
            )}
            minDate={minDate.toDate()}
            readOnly={readonly}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default CustomDate;
